/**
 * Explicacao de cada metrica dos indicadores (Mapa de Calor, Analise de
 * Cobertura e Boletim de Urna). Texto unico para as tres telas dizerem a mesma
 * coisa sobre o mesmo numero.
 */
export const DESCRICOES = {
  cadastros:
    "Quantidade de pessoas cadastradas na área. Mostra onde a equipe concentrou o trabalho de cadastro.",
  eleitorado:
    "Eleitores aptos da área, segundo o TSE. É a base para comparar áreas de tamanhos diferentes.",
  penetracao:
    "Cadastrados ÷ eleitorado da área. Mostra que parte do eleitorado local a equipe alcançou e permite comparar áreas de tamanhos diferentes.",
  oportunidade:
    "Eleitores da área ainda não cadastrados (eleitorado − cadastrados). Indica onde ainda há espaço para crescer.",
  assessoresAtuantes:
    "Quantos assessores diferentes cadastraram pessoas na área. Mostra a presença da equipe e as áreas descobertas.",
  assessoresCobertura:
    "Quantos assessores têm esta área declarada na sua atuação (cadastro do assessor). Zero indica área descoberta.",
  votos:
    "Votos do candidato na área, segundo o boletim de urna importado. Mostra onde o candidato foi votado.",
  participacao:
    "Votos ÷ eleitorado da área. Mede a força do voto independentemente do tamanho da área: um bairro pequeno pode ter participação maior que um grande.",
  conversao:
    "Votos ÷ cadastros da área. Pode passar de 100% quando o candidato teve votos além das pessoas cadastradas.",
  aproveitamento:
    "Quanto do cadastro virou voto: em cada seção, votos ÷ cadastros (no máximo 1), somado por pessoa e dividido pelos cadastrados da área. Baixo indica cadastro que não se converteu em voto.",
  pontuacao:
    "Soma dos fatores dos cadastros. Cada pessoa recebe o fator da sua seção (votos ÷ cadastros, no máximo 1); a pontuação nunca passa dos votos da área.",
  fator:
    "Votos da seção ÷ cadastros da seção, com teto 1. Todo cadastro da seção recebe esse valor. 1 = a seção teve pelo menos um voto por cadastro.",
  fatorZona:
    "Pontuação ÷ cadastros da zona: a média dos fatores das seções, ponderada pelo número de cadastros.",
  fatorMeta:
    "Igual ao fator, mas contando só os cadastros desta meta na seção: cada meta é comparada isoladamente com os votos da seção (no máximo 1).",
  pontuacaoMeta:
    "Soma dos fatores meta dos cadastros. Como cada meta disputa todos os votos da seção, as metas somadas podem passar do total de votos.",
  alvo: "Quantidade de cadastros que a meta prevê para cada assessor.",
  assessoresMeta: "Quantos assessores do candidato estão nesta meta.",
  secoesComVoto: "Seções da zona em que o candidato teve pelo menos um voto.",
  votosSemCadastro:
    "Votos em seções onde a equipe não tem nenhum cadastro: voto conquistado sem trabalho de cadastro direto.",
  cadSemVoto:
    "Cadastros em seções onde o candidato não teve nenhum voto. Considera só seções que existem na base do TSE.",
  votosZonaSemAssessor:
    "Votos em zonas eleitorais sem nenhum assessor atuando: voto conquistado sem cobertura da equipe.",
};
